import React from 'react';
import AppRoutes from './app-routes.js';
import { UserDetailsProvider, WindowWidthProvider } from './context/user-details-context.js';
import { createTheme, ThemeProvider } from '@mui/material';

const AAACreator = () => {
  const theme = createTheme();
  return (
    <UserDetailsProvider>
      <WindowWidthProvider>
        <ThemeProvider theme={theme}>
          <React.StrictMode>
            <AppRoutes />
          </React.StrictMode>
        </ThemeProvider>
      </WindowWidthProvider>
    </UserDetailsProvider>
  )
}

export default AAACreator;